<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content" >
            <h2 data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1200">About Us</h2>
            <ul data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1200">
                <li><a routerLink="/">Home</a></li>
                <li>About Us</li>
            </ul>
        </div>
    </div>
   
        
      
</div>
<!-- End Page Title Area -->

<!-- Start About Area -->
<section class="features-area ptb-110">
    <div class="container-fluid">
        <div class="overview-box"   >
            <div class="content" data-aos="fade-right" >
                <!-- <span>About Us</span> -->
                <h3>
                    Thriving in the Era of Modern Technology
                </h3>
                <img src="assets/img/RO.gif" style="height: 30px" />
                <p>
                    In today's fast-paced world, people crave convenience and connection. At Vocbot, we're passionate about harnessing the power of voice technology to transform how you interact with your customers and streamline your operations.
                </p>
                <!-- <p>
                    Vocbot recognizes this need and presents a user-friendly technological solution tailored for businesses of all sizes. With a commitment to accessibility, Vocbot empowers businesses to seamlessly integrate automation, providing the necessary tools for success in an ever-evolving business environment.
                </p> -->
                <!-- <p>
                    Seeking the vision for Automation Vocbot has come up with a technology that is easy to use for businesses of all sizes.
                </p> -->
            </div>

            <!-- <div class="col-lg-6 col-md-12"> -->
                <div class="image wow zoomIn" data-wow-delay="1s" data-aos="fade-left"  >
                    <img src="assets/img/5604134_2920271.jpg" alt="image">
                </div>
            <!-- </div> -->
        </div>

        <div class="about-inner-area">
            <div class="row">
               
                <div class="col-lg-4 col-md-6 col-sm-6" data-aos="zoom-in-down">
                    <div class="about-text"  >
                        <h3>Our Vision</h3>
                        <p>
                            We aspire to enhance the customer care service user experience through innovative approaches and distinctive ideas.
                        </p>

                        <i class="flaticon-house"></i>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6" data-aos="zoom-in-down">
                    <div class="about-text"  >
                        <h3>Our Mission</h3>
                        <p>
                            Our goal is to ensure that every caller's experience is enjoyable and satisfying, achieved through our inventive and unique approach to customer care.
                        </p>

                        <i class="flaticon-insurance"></i>
                    </div>
                </div>

                <div class="col-lg-4 col-md-12 col-sm-6 " data-aos="zoom-in-down">
                    <div class="about-text"  >
                        <h3>Who we are</h3>
                        <p>
                            We're a team of innovative voice technology experts dedicated to building intelligent voice solutions that enhance customer experience, improve efficiency, drive sales, reduce waiting time and reduce operations cost.  We believe voice assistants are the future of human-computer interaction, and we're here to help you unlock their potential.
                        </p>

                        <i class="flaticon-box"></i>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
     
</section>
<!-- End About Area -->

<app-funfact></app-funfact>
